import {atom} from 'jotai';

/**
 * 로그인 직후 보유 쿠폰 알림의 판정 결과.
 * 컴포넌트가 재마운트돼도(개발 StrictMode, 라우트 이동 등) 유지되어야 하므로 atom 으로 둔다.
 * userId 를 함께 담아 같은 탭에서 계정을 바꾸면 다시 판정한다.
 */
export const couponLoginAlertAtom = atom<{
  userId: string;
  state: 'visible' | 'done';
} | null>(null);
